<template>
<div class="body apply">
    <div class="wrap" style="width: inherit !important;">
        <div class="apply-menu-wrap1">
            <div class="top-menu">
                <h1>
                    <img v-if="logo" :src="logo" alt="company logo">
                    <div v-else style="height: 25px;" />
                    <!-- <span>사내어학과정</span> -->
                    <div style="height:30px;"></div>
                </h1>
                <!-- 모바일용 -->
                <a href="#" class="dp-inblock-m m-menu" id="header-menu-btn">
                    <img src="../../assets/img/m_gnb_sub.png" alt="menu">
                </a>
                <ul>
                    <li class="on-blue">
                        <a>신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
            <!-- 반응형 메뉴 -->
            <div class="dp-inblock-m m-top-menu" id="header-menu">
                <a href="#" class="close" id="header-close">
                    <img src="../../assets/img/menu_close.png" alt="">
                </a>
                <ul class="clear">
                    <li><a class="pointer">신청하기</a></li>
                    <li><a class="pointer">신청내역 확인</a></li>
                    <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
                    <li><a class="pointer">Logout</a></li>
                </ul>
            </div>
        </div>
        <div class="con">
            <div class="title">
                <h2>사전 유의사항</h2>
                <p>아래의 유의사항을 꼭 확인해 주세요.</p>
            </div>
            <progress-bar></progress-bar>
            <div class="mt-50">
                <div class="apply-agree-wrap">
                    <div class="apply-agree" v-for="(item, index) of agreeInfo" :key="index">
                        <input type="checkbox" v-model="item.agree" class="option-input radio" name="example" checked>
                        <label for="" class="">
                            <span class=""></span>
                            <span class="agree-text pointer" @click="item.agree = !item.agree">{{item['agree_title' + (index + 1)]}}</span>
                        </label>
                        <p class="preline" v-html="item['agree_contents' + (index + 1)]">
                        </p>
                    </div>
                    <div class="apply-agree">
                        <input type="checkbox" v-model="isAllAgree" @click="allAgree()" class="option-input radio" name="example">
                        <label for="" class="">
                            <span class=""></span>
                            <span class="pointer" @click="allAgree()">모두 동의합니다.</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="apply-agree-btn">
                <button type="button">위 사전 유의사항에 동의합니다.</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    data: () => ({
        isStandardAgree: false,
        isWithdrawAgree: false,
        isAllAgree: false,
        agreeInfo: [],

        mainIdx: {}, // 미리보기 api호출을 위한 mainIdx

        logo: '' // 미리보기 로고 url용
    }),

    mounted() {
        console.log('this.$route.params', this.$route.params)

        var oParams = GetUrlParams()
        this.mainIdx = oParams.mainIdx

        console.log('this.mainIdx', this.mainIdx)

        var summaryIdx = this.mainIdx
        var params = {
            summaryIdx: summaryIdx
        }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/agree/${summaryIdx}`, {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.logo = res.data.agreeInfo.company_logo_file_url

                var idx = 0
                for (var item of Object.keys(res.data.agreeInfo)) {
                    if (item.includes('agree_contents')) {
                        idx += 1
                    }
                }

                for (var i = 1; i <= idx; i++) {
                    var tempObj = {}
                    tempObj['agree'] = false
                    tempObj['agree_title' + i.toString()] = res.data.agreeInfo['agree_title' + i.toString()]
                    tempObj['agree_contents' + i.toString()] = res.data.agreeInfo['agree_contents' + i.toString()]
                    this.agreeInfo.push(tempObj)
                }
                console.log('this.agreeInfo', this.agreeInfo)
            } else {
                alert(res.data.result)
            }
        })
    },

    watch: {
        // 오브젝트 안에 각각 동의 여부를 감지하는 로직
        agreeInfo: {
            handler() {
                var check = true
                for (let item of this.agreeInfo) {
                    if (!item.agree) {
                        check = false
                        break
                    }
                }

                if (check) {
                    this.isAllAgree = true
                } else {
                    this.isAllAgree = false
                }
            },
            deep: true
        }
    },

    methods: {
        // 모두 동의합니다 버튼
        allAgree() {
            if (!this.isAllAgree) {
                for (let item of this.agreeInfo) {
                    item.agree = true
                }
            } else {
                for (let item of this.agreeInfo) {
                    item.agree = false
                }
            }
        },
        // 약관 동의 검사 및 다음 페이지 이동
        agree() {
            if (!this.isAllAgree) {
                alert('위의 모든 약관에 동의해주세요')
                return false
            } else {
                var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                var idx = pOrder.indexOf('terms') + 1
                sessionStorage.setItem('step', pOrder[idx])
                this.$router.push(`/user/reg/${pOrder[idx]}`)
            }
        }
    }
}
</script>
